import consoleLogger from './providers/console';

export interface LogProviderInterface {
    logMessage: (message: string) => void;
    logWarning: (message: string) => void;
    logError: (message: any, transactionName?: string) => void;
    setUser: (id: string) => void;
    cleanUser: () => void;
}

const logProviders: LogProviderInterface[] = [consoleLogger];

/**
 * Log generic messages here
 * @param {string} message
 */
const logMessage = (message: string) => {
    for (const provider of logProviders) {
        provider.logMessage(message);
    }
};

/**
 * Log warning messages here
 * @param {string} message
 */
const logWarning = (message: string) => {
    for (const provider of logProviders) {
        provider.logWarning(message);
    }
};
/**
 * Log error messages here
 * @param {string} message
 */
const logError = (error: any, transactionName?: string) => {
    for (const provider of logProviders) {
        provider.logError(error, transactionName);
    }
};

/**
 * Set user id
 * @param {string} id string
 */
const setUser = (id: string) => {
    for (const provider of logProviders) {
        if (provider.setUser) provider.setUser(id);
    }
};

/**
 * Clean user
 */
const cleanUser = () => {
    for (const provider of logProviders) {
        if (provider.cleanUser) provider.cleanUser();
    }
};

export default {
    logMessage,
    logWarning,
    logError,
    setUser,
    cleanUser,
} as LogProviderInterface;
